import React from "react";
import { Check } from "lucide-react";

const ProblemsAndSolutions = ({ onGetStarted }) => {
  return (
    <section className="py-10 md:py-10 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-16">
          

          <div className="space-y-2">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Multiple problems
            </h2>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-green-500 leading-tight">
              One solution
            </h2>
          </div>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          {/* Problems Column */}
          <div className="space-y-6">
            {/* Problem 1 */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <div className="flex items-start gap-4">
                <img 
                  src="https://i.pravatar.cc/150?img=1" 
                  alt="User" 
                  className="w-12 h-12 rounded-full flex-shrink-0"
                />
                <div className="flex-1">
                  <p className="text-gray-600 leading-relaxed">
                    Monthly costs for <span className="text-orange-600 font-semibold">ahrefs</span>,{" "}
                    <span className="text-gray-700 font-semibold">SURFER</span>,{" "}
                    <span className="text-blue-500 font-semibold">Canva</span> consume{" "}
                    <span className="text-red-500 font-semibold">$500+</span> of your marketing spend.
                  </p>
                </div>
              </div>
            </div>

            {/* Problem 2 */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <div className="flex items-start gap-4">
                <img 
                  src="https://i.pravatar.cc/150?img=2" 
                  alt="User" 
                  className="w-12 h-12 rounded-full flex-shrink-0"
                />
                <div className="flex-1">
                  <p className="text-gray-600 leading-relaxed">
                    Jumping between: <span className="font-semibold">ChatGPT</span>,{" "}
                    <span className="font-semibold">WEGLOT</span>,{" "}
                    <span className="text-gray-700 font-semibold">SURFER</span>{" "}
                    <span className="text-red-500 font-semibold">wastes time and kills productivity.</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Problem 3 */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <div className="flex items-start gap-4">
                <img 
                  src="https://i.pravatar.cc/150?img=3" 
                  alt="User" 
                  className="w-12 h-12 rounded-full flex-shrink-0"
                />
                <div className="flex-1">
                  <p className="text-gray-600 leading-relaxed">
                    <span className="text-red-500 font-semibold">Countless hours mastering SEO platforms</span>{" "}
                    when you should be scaling your business.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Solution Card */}
          <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-2xl shadow-lg p-8">
            {/* Logo/Brand */}
            <div className="mb-6">
              <img 
                src="/Hyperrank White Logo.png" 
                alt="Hyperrank" 
                className="h-8"
              />
            </div>

            {/* Description Box */}
            <div className="bg-white rounded-xl p-6 text-gray-800">
              <p className="text-gray-600 leading-relaxed mb-6">
                Consolidate your toolkit into one comprehensive platform:
              </p>

              {/* Features List */}
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="h-4 w-4 text-green-600 stroke-[2.5]" />
                  </div>
                  <span className="text-gray-900 leading-relaxed">Keyword Research</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="h-4 w-4 text-green-600 stroke-[2.5]" />
                  </div>
                  <span className="text-gray-900 leading-relaxed">Content Creation</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="h-4 w-4 text-green-600 stroke-[2.5]" />
                  </div>
                  <span className="text-gray-900 leading-relaxed">SEO Optimization</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="h-4 w-4 text-green-600 stroke-[2.5]" />
                  </div>
                  <span className="text-gray-900 leading-relaxed">Competitor Analysis</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="h-4 w-4 text-green-600 stroke-[2.5]" />
                  </div>
                  <span className="text-gray-900 leading-relaxed">Visual Assets</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="h-4 w-4 text-green-600 stroke-[2.5]" />
                  </div>
                  <span className="text-gray-900 leading-relaxed">Multi-language Support</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemsAndSolutions;

